import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getUserById = (id) => {
    return axios.get(`${backendHost}/api/admin/user/${id}`);
};